/** Parse favourited_by / permission id arrays from API rows. */
export function parseStudentIdList(value) {
  if (value == null) return [];
  let raw = value;
  if (typeof raw === 'string') {
    try {
      raw = JSON.parse(raw);
    } catch {
      return [];
    }
  }
  if (!Array.isArray(raw)) return [];
  return [...new Set(raw.map((x) => parseInt(String(x), 10)).filter(Number.isFinite))];
}

export function readFavouritesFromNote(note) {
  if (!note) {
    return { isFavourite: false, favouritedBy: [] };
  }
  const isFavourite = note.isFavourite === true || note.is_favourite === true;
  const favouritedBy = parseStudentIdList(note.favouritedBy ?? note.favourited_by);
  return { isFavourite, favouritedBy };
}

/** Star filled for current user (author: isFavourite; shared note: id in favouritedBy). */
export function isNoteStarredForUser(note, userId) {
  if (note == null || userId == null) return false;
  const uid = Number(userId);
  const authorId = Number(note.created_by ?? note.createdBy);
  const { isFavourite, favouritedBy } = readFavouritesFromNote(note);
  if (Number.isFinite(authorId) && authorId === uid) {
    return isFavourite;
  }
  return favouritedBy.includes(uid);
}

export function isOwnStudentNote(note, userId) {
  if (note == null || userId == null) return false;
  return Number(note.created_by ?? note.createdBy) === Number(userId);
}
